import { compStyles } from '../styleBased/compStylesCompNode'
import { themeVariants } from '../styleBased/themeVariantsCompNode'
import type { StylableCssFeature } from './stylable.types'
import { stylableCss } from './stylableCompNode'
import { stylableCssDomApplier } from './stylableCssDomApplier'
import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'

export const stylableCssFeature: StylableCssFeature = {
	featureName: 'stylableCss',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { stylableCss: stylableCss(false), themeVariants },
	intermediateNodes: { compStyles },
	dataMaps: ['theme_data', 'variants_data'],
	domApplier: stylableCssDomApplier,
}

export const editorStylableCssFeature: StylableCssFeature = {
	...stylableCssFeature,
	renderableNodes: { stylableCss: stylableCss(true), themeVariants },
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(stylableCssFeature)
}

export const editor: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(editorStylableCssFeature)
}
